import { Module } from '@nestjs/common';

import { AppController } from './app.controller';
import { AppService } from './app.service';
import { BiMessage } from './entity/bi-message.entity';
import { MessageBroadcastModule } from './message-broadcast/message-broadcast.module';
import { appConfig } from '../../config';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Company } from './entity/company.entity';
import { CompanyModule } from './company/company.module';
import { ModuleModule } from './module/module.module';
import { Modules } from './entity/module.entity';
import { BiMessageModule } from './bi-message/bi-message.module';
import { BroadcastMessage } from './message-broadcast/entity/broadcast-message.entity';
import { BroadcastContact } from './message-broadcast/entity/broadcast-contact.entity';
import { CompanyBiMessage } from './entity/company-bi-message.entity';
import { BloodDonationUser } from './message-broadcast/entity/blood-donation-users.entity';
import { WhatsappLogEntity } from './entity/whats-app-log.entity';
import {ScheduleModule} from '@nestjs/schedule'
import { Application } from './entity/application.entity';
import { ApplicationModule } from '../../applications/application.module';

@Module({
  
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',//appConfig.database.type, have to fix tsconfig
      timezone: 'Z',
      host: appConfig.database.host,
      port: appConfig.database.port,
      username: appConfig.database.username,
      password: appConfig.database.password,
      database: appConfig.database.dbName,
      entities: [
        Company,
        Modules,
        BiMessage,
        BroadcastMessage,
        BroadcastContact,
        CompanyBiMessage,
        BloodDonationUser,
        WhatsappLogEntity,
        Application
      ],
      // synchronize: false,
      logging: false,
      extra: {
        connectionLimit: appConfig.database.poolLimit
      }
    }),
    MessageBroadcastModule,
    CompanyModule,
    ModuleModule,
    BiMessageModule,
    ApplicationModule,
  ScheduleModule.forRoot(),


  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
